import { Instance, types } from 'mobx-state-tree';
import { OrderItem } from './model/OrderItem';

export const OrderSummaryStore = types
  .model('OrderSummaryStore', {
    externalReferenceId: types.string,
    enrollmentItems: types.array(OrderItem),
    essentialRewardItems: types.array(OrderItem),
    editStepNumber: types.number,
    hideEditStepButton: types.boolean,
    isMeoEnabled: types.boolean,
    usePremiumStarterKitAsErOrder: types.boolean,
    orderWeight: types.optional(types.number,0)
  })
  .views(self => ({
    get isErEnrollment() {
      return self.essentialRewardItems.length > 0;
    }
  }));

export type OrderSummaryStore = Instance<typeof OrderSummaryStore>;
